import { Fragment } from 'react';
import { classNameTriskeleParser } from '../utilities/customStyles';
import {
  BODY_TEXT_NAVY_1,  Heading5500C, Heading6500N
} from '../utilities/generatedClasses';

const MeasuresList = (props) => {
  const {
    filteredMeasures, setAction, title, container, type, topSize
  } = props;
  return (
    <div className='add-recommendation-grid-left'>
      {title
                && <div className={`list-title ${Heading6500N}`}>{title}</div>
            }
      {filteredMeasures && filteredMeasures.map(measure => (
        <Fragment key={measure.name}>
          {
                            measure.values.length > 0
                            && (
                            <div>
                              <div
                                className={`analytic_title ${Heading5500C}`}
                                style={{ top: type === 'report' ? topSize : '0px' }}
                                >{measure.name}
                              </div>

                              <div className={container} >
                                {measure && measure.values.map(value => (
                                  <div key={type === 'report' ? value.ReportName : value.MeasureName} style={{ width: '100%' }} onClick={() => setAction(value)} aria-hidden="true">
                                    <div
                                      className={`MeasuresCard ${value.VisualNameTwo ? classNameTriskeleParser(value.VisualNameTwo, value.VisualTypeTwo, 'Card') : classNameTriskeleParser('Measure Card', 'Enabled', 'Card')}`}
                                      style={{ height: '75px' }}
                                                >
                                      <div
                                        style={{ WebkitMaskImage: `${type === 'report' ? `url(${value.ReportIcon})` : value.MeasureIcon}` }}
                                        className={`MeasureIcon ${value.VisualNameOne !== '' && value.VisualTypeOne !== '' ? classNameTriskeleParser(value.VisualNameOne, value.VisualTypeOne, 'Icon') : ''} icon-margin-10px size-50`}
                                        />
                                      <label
                                        className={value.VisualNameTwo ? classNameTriskeleParser(value.VisualNameTwo, value.VisualTypeTwo, 'Text') : BODY_TEXT_NAVY_1}
                                        style={{ margin: 0, fontWeight: '300' }}>{type === 'report' ? value.ReportName : value.MeasureName}
                                      </label>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                            )
                }
        </Fragment>
      ))}
    </div>
  );
};

export default MeasuresList;
